/**
 * Chinese Products Translations
 * 产品页翻译模块 - 中文
 *
 * 包含产品列表、产品详情、五个产品完整翻译
 */

import type { ProductsTranslations } from '../../types';

export const zhProducts: ProductsTranslations = {
  title: '全部产品',
  subtitle: '为您的空间找到完美的取暖解决方案',
  viewDetails: '查看详情',
  header: {
    title: '全部产品',
    subtitle: '为您的家庭、办公室或工业空间找到完美的取暖解决方案。',
  },
  filters: {
    all: '全部',
    searchPlaceholder: '搜索产品...',
  },
  catalog: '下载完整目录',
  discoverMore: '探索更多',
  viewSpecs: '查看规格',
  categories: {
    infraredHeater: '红外取暖器',
    portableHeater: '便携式取暖器',
    gasHeater: '燃气取暖器与火炉桌',
  },
  navDesc: {
    infrared: '壁挂与吊顶辐射取暖板',
    portable: '落地、桌面与吊装款式',
    gas: '户外燃气取暖器与火炉桌',
  },
  viewAllProducts: '查看全部产品',
  gasSubtitle: '面向露台及户外商业休闲空间的燃气取暖器和火炉桌。',
  categoryLanding: {
    gas: {
      title: '燃气取暖器与火炉桌',
      subtitle:
        '输出功率覆盖 8 kW 至 50,000 BTU，配备 304 不锈钢燃烧器与玻璃防风罩，可按目标市场配置 LPG 气源。',
      empty: '该分类下暂无产品。',
    },
    infrared: {
      title: '红外取暖器',
      subtitle: '高效辐射供暖，提供精准、舒适的暖意——适用于露台、车间与舒适分区等场景。',
      empty: '该分类下暂无产品。',
    },
    portable: {
      title: '便携式取暖器',
      subtitle: '面向家庭与办公的灵活取暖方案——易移动、升温快，适合日常舒适使用。',
      empty: '该分类下暂无产品。',
    },
  },
  detail: {
    technicalSpecs: '技术规格',
    relatedProducts: '相关{{category}}产品',
    requestQuote: '获取报价',
    backToProducts: '返回产品列表',
    productNotFound: '未找到产品',
    specsAvailableOnRequest: '规格详情请咨询获取。',
    noMatchingProducts: '暂无匹配的产品',
    noProducts: '暂无产品数据',
  },
  items: {
    p1: {
      name: '13A \u7cfb\u5217',
      description: '节能户外远红外取暖器，航空级弧形加热元件。1000W-4000W多功率可选，适用于露台、餐厅、车间等场所。',
      longDescription:
        '13A系列是专为户外和半户外空间设计的远红外辐射取暖器。不同于传统对流加热器浪费能源加热空气，本产品将高达99%的电能直接转化为热辐射，功耗降低最高达80%。航空级加热元件配合弧形加热板，提供大面积均匀散热。IPX4防水等级和静音运行，适合餐厅露台、户外阳台、阳光房和车间使用。功率覆盖1000W至4000W，供暖面积10-50平方米。',
      category: '红外取暖器',
      features: ['环保节能', '安全静音', '长寿命', '350°C 高温'],
      specs: [
        { label: '型号', value: 'NR10/18/24/32/40-13A' },
        { label: '功率', value: '2400W' },
        { label: '加热面积', value: '30 m²' },
        { label: '电压/频率', value: '230V, 50/60Hz' },
        { label: '额定电流', value: '10.4A' },
        { label: '表面温度', value: '300°C' },
        { label: '尺寸', value: '1500×189×67mm' },
        { label: '净/毛重', value: '8.8/10.6 kg' },
      ],
    },
    p2: {
      name: '13B \u7cfb\u5217',
      description: '带遥控和温控的壁挂式远红外取暖器。节能辐射加热，适合客厅、卧室和办公室。',
      longDescription:
        '13B系列是一款经典壁挂式远红外取暖器，具有出色的节能表现。内置温控器和遥控器可自动维持设定温度，避免能源浪费。红色LED指示灯实时显示加热状态。航空级加热元件配合弧形加热板，电热转换率达99%。静音、无尘的辐射加热方式，非常适合客厅、卧室和办公室等需要安静舒适环境的场所。',
      category: '红外取暖器',
      features: ['遥控操作', 'LED指示灯', '环保节能', '高效加热', '300°C表面'],
      specs: [
        { label: '型号', value: 'NR10/18/24/32-13B' },
        { label: '功率', value: '2400W' },
        { label: '加热面积', value: '30 m²' },
        { label: '电压/频率', value: '230V, 50/60Hz' },
        { label: '额定电流', value: '10.4A' },
        { label: '表面温度', value: '300°C' },
        { label: '尺寸', value: '1500×189×67mm' },
        { label: '净/毛重', value: '8.8/10.6 kg' },
      ],
    },
    p3: {
      name: '13C \u7cfb\u5217',
      description: '内置蓝牙音箱的远红外露台取暖器。4档功率，纳米涂层面板，适合户外餐厅和休闲娱乐区。',
      longDescription:
        '13C系列将远红外加热与娱乐功能合二为一——既是取暖器也是蓝牙音箱。通过内置3D立体音箱播放手机音乐，同时享受静音辐射温暖。纳米涂层加热面板具有高红外发射率，实现高效能量转换。4档功率设置（25%-100%）可按需调节热量输出。非常适合户外餐厅露台、娱乐休闲区和半户外空间使用。',
      category: '红外取暖器',
      features: ['蓝牙音箱', '4档功率', '远红外舒适取暖', '蓝牙音频', '静音运行'],
      specs: [
        { label: '型号', value: 'NR10/18/24/32-13C' },
        { label: '功率', value: '1800W' },
        { label: '加热面积', value: '20 m²' },
        { label: '电压/频率', value: '230V, 50/60Hz' },
        { label: '额定电流', value: '7.8A' },
        { label: '表面温度', value: '300°C' },
        { label: '尺寸', value: '1370×189×67mm' },
        { label: '净/毛重', value: '8.3/10.2 kg' },
        { label: '装柜量', value: '705/1632; 480/1156; 355/884; 270/612' },
      ],
    },
    p4: {
      name: '22B \u7cfb\u5217',
      description: '高端玻璃陶瓷远红外面板取暖器，支持WiFi涂鸦APP控制。1600W-3200W辐射加热，适合现代客厅和办公室。',
      longDescription:
        '22B系列是一款高端远红外面板取暖器，采用耐温950°C的玻璃陶瓷加热面板。特殊的玻璃反射效果营造出现代时尚的外观。通过WiFi涂鸦APP或附带的遥控器远程控制——设定时间计划、调节温度、从手机端节省能耗。提供清洁辐射温暖，无噪音、无风扇、不干燥空气。远红外波段还有助于促进新陈代谢的健康功效。1600W、2200W和3200W三种型号可选，覆盖20-40平方米。',
      category: '红外取暖器',
      features: ['WiFi涂鸦APP', '遥控操作', '玻璃陶瓷面板', '快速加热', '保健功能'],
      specs: [
        { label: '型号', value: 'NR16/22/32-22B' },
        { label: '功率', value: '1.6/2.2/3.2 kW' },
        { label: '覆盖面积', value: '20/30/40 m²' },
        { label: '电压/频率', value: '220-240V~50/60Hz' },
        { label: '额定电流', value: '7/9.6/13.9A' },
        { label: '表面温度', value: '380°C' },
        { label: '尺寸', value: '810/1160/1660 × 180 × 77 mm' },
        { label: '净/毛重', value: '5/6.1; 7/8.2; 9.9/11.7 kg' },
        { label: '装柜量', value: '728/1638; 507/1162; 377/826' },
      ]
    },
    p5: {
      name: '13W \u7cfb\u5217',
      description: '支持WiFi APP控制的智能远红外取暖器，IPX4防水。适用于室内外露台、阳台和庭院的辐射加热。',
      longDescription:
        "13W 系列配备涂鸦 WiFi APP、LCD 遥控器、LED 状态显示和四档功率。适用于室内房间及有合适安装墙面的有顶露台或阳台，需使用对应挂架并按型号要求预留间距。IPX4 表示防溅水性能。",
      category: '红外取暖器',
      features: ['WiFi涂鸦APP', 'LED显示', 'LCD遥控', '4档功率', 'IPX4防水'],
      specs: [
        { label: '型号', value: 'NR10/18/24/32-13W' },
        { label: '功率', value: '1.0/1.8/2.4/3.2 kW' },
        { label: '覆盖面积', value: '10/20/30/40 m²' },
        { label: '电压/频率', value: '220-240V~50/60Hz' },
        { label: '额定电流', value: '4.3/7.8/10.4/13.9A' },
        { label: '表面温度', value: '300°C' },
        { label: '尺寸', value: '755/1150/1655/2155 × 189 × 67 mm' },
        { label: '净/毛重', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: '装柜量', value: '840/1680/2100; 530/1080/1350; 570/900/980; 350/700/800' },
      ]
    },
    p6: {
      name: '14A \u7cfb\u5217',
      description: '经典弧形远红外取暖器，纳米涂层面板。1000W-4000W节能辐射加热，适用于露台、阳台和庭院。',
      longDescription:
        "14A 系列采用拱形纳米涂层面板，提供 1000W 至 4000W 功率选择，无内置控制器。请在室内或有顶区域选择合适安装墙面，并确认所选型号的挂架、安装间距与控制配置。IPX4 表示防溅水性能。",
      category: '红外取暖器',
      features: ['弧形设计', '多种功率', 'IPX4防水', '快速加热', '高效节能'],
      specs: [
        { label: '型号', value: '' },
        { label: '功率', value: '' },
        { label: '覆盖面积', value: '' },
        { label: '电压/频率', value: '' },
        { label: '额定电流', value: '' },
        { label: '表面温度', value: '' },
        { label: '尺寸', value: '' },
        { label: '净/毛重', value: '' },
        { label: '装柜量', value: '' },
      ]
    },
    p7: {
      name: '14B \u7cfb\u5217',
      description: "遥控式壁挂远红外取暖器，适用于室内房间及有合适安装墙面的有顶露台。",
      longDescription:
        "14B 系列采用拱形纳米涂层面板，配备遥控器、LED 指示灯、四档功率及 0/2/4/6/8 小时定时。需使用对应挂架安装于室内或有顶区域的合适墙面，并预留规定间距。机身纤薄不代表可安装于其他支撑结构。",
      category: '红外取暖器',
      features: ['遥控操作', '定时功能', '弧形设计', 'IPX4防水', '快速加热'],
      specs: [
        { label: '型号', value: '' },
        { label: '功率', value: '' },
        { label: '覆盖面积', value: '' },
        { label: '电压/频率', value: '' },
        { label: '额定电流', value: '' },
        { label: '表面温度', value: '' },
        { label: '尺寸', value: '' },
        { label: '净/毛重', value: '' },
        { label: '装柜量', value: '' },
      ]
    },
    p8: {
      name: '23W \u7cfb\u5217',
      description: '超薄远红外取暖器，支持 Tuya Smart WiFi App、语音控制、遥控和定时，适用于室内及有顶露台。',
      longDescription:
        "23W 系列采用纤薄黑色纳米涂层面板，支持涂鸦智能 WiFi APP 及兼容的语音控制。随附遥控器可选择四档功率和 0/2/4/6/8 小时定时。需使用对应挂架固定于室内或有顶区域的合适墙面，并按该型号要求预留间距。",
      category: '红外取暖器',
      features: ['Tuya Smart App', '语音控制', '遥控操作', '定时功能', '4档功率', '快速加热'],
      specs: [
        { label: '型号', value: 'NR10/18/24/32-23W' },
        { label: '功率', value: '1.0/1.8/2.4/3.2 kW' },
        { label: '覆盖面积', value: '10/20/30/40 m²' },
        { label: '电压/频率', value: '220-240V~50/60Hz' },
        { label: '额定电流', value: '4.3/7.8/10.4/13.9A' },
        { label: '表面温度', value: '300°C' },
        { label: '尺寸', value: '693/1093/1593/2093 × 151 × 52 mm' },
        { label: '净/毛重', value: '3.4/4.2; 5.3/6.4; 7.6/9.5; 9.9/12.5 kg' },
        { label: '装柜量', value: '1248; 800; 528; 412 (20HQ)' },
      ]
    },
    p20: {
      name: '23A \u7cfb\u5217',
      description: '超薄远红外取暖器，配备普通遥控器、定时和 4 档功率，无需 WiFi 或 App。',
      longDescription:
        '23A 系列是一款通过普通实体遥控器操作的超薄远红外取暖器，不支持 WiFi 或 App 连接。遥控器提供 4 档功率（25%/50%/75%/100%）和 0/2/4/6/8 小时定时。纤薄的黑色纳米涂层面板带来快速、均匀、静音且无明火的辐射供暖。1000W 至 3200W 可选，覆盖 10-40 m²；52mm 机身适合住宅、餐厅、办公室和有顶露台。',
      category: '红外取暖器',
      features: ['遥控操作', '定时功能', '4档功率', '超薄设计', '快速加热', '静音运行'],
      specs: [
        { label: '型号', value: '' },
        { label: '功率', value: '' },
        { label: '覆盖面积', value: '' },
        { label: '电压/频率', value: '' },
        { label: '额定电流', value: '' },
        { label: '表面温度', value: '' },
        { label: '尺寸', value: '' },
        { label: '净/毛重', value: '' },
        { label: '装柜量', value: '' },
      ]
    },
    p21: {
      name: '25W 系列',
      description: '内置 WiFi 的壁挂式远红外取暖器，支持涂鸦 APP 控制与 LED 档位显示，1000W 至 3200W 四档功率。',
      longDescription:
        '25W 系列是一款超薄壁挂式远红外取暖器，内置 WiFi 模块，可接入涂鸦智能 APP——在手机上开关设备、切换功率档位并设置定时计划，也可使用随机附带、带 WiFi 配对键的无线遥控器。机身控制盒上的红色 LED 显示屏显示当前功率档位。四档功率覆盖 1000W 至 3200W、10 m² 至 40 m²，全系共用同一 67mm 铝制机身。盘绕式远红外发热元件沿铝制型材内部贯穿整块面板，使带槽铝制面板表面温度达到 300°C。',
      category: '红外取暖器',
      features: ['WiFi涂鸦APP', 'LED档位显示', '无线遥控', '4档功率', '300°C表面温度', '67mm超薄机身'],
      specs: [
        { label: '型号', value: 'NR10/18/24/32-25W' },
        { label: '功率', value: '1.0/1.8/2.4/3.2 kW' },
        { label: '覆盖面积', value: '10/20/30/40 m²' },
        { label: '电压/频率', value: '220-240V~50/60Hz' },
        { label: '额定电流', value: '4.3/7.8/10.4/13.9A' },
        { label: '表面温度', value: '300°C' },
        { label: '尺寸', value: '715/1115/1615/2115 × 189 × 67 mm' },
        { label: '净/毛重', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: '装柜量', value: '945/1920/2176; 615/1290/1462; 435/885/1003; 345/705/799' },
      ]
    },
    p9: {
      name: 'JHL020A',
      description: '小巧便携的碳纤维取暖器，配备倾倒保护功能。适合桌面下或桌下个人取暖。',
      longDescription:
        'JHL020A是一款专为个人取暖设计的高效桌下取暖器。采用碳纤维加热管，实现快速均匀的加热效果。配备拨动开关控制和倾倒保护功能，安全可靠。凉触网设计有效防止烫伤，同时提供高效温暖。轻便的结构配合欧式插头，非常适合家庭或办公室使用。',
      category: '便携式取暖器',
      features: ['倾倒保护', '凉触网设计', '小巧便携', '快速加热', '高效节能'],
      specs: [
        { label: '型号', value: 'JHL020A' },
        { label: '产品名称', value: '桌下取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '1200W' },
        { label: '控制方式', value: '拨动开关' },
        { label: '加热元件', value: '1根碳纤维加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '材质', value: '铁、铝合金' }
      ]
    },
    p10: {
      name: 'JHL023',
      description: '大功率碳纤维取暖器，双档加热设置，配折叠手柄。适用于任何空间的便携式取暖解决方案。',
      longDescription:
        'JHL023是一款功能强大且便于携带的落地式取暖器，配备双碳纤维加热管，提供高效温暖。两档加热设置（750W + 750W）实现灵活温度控制。旋转开关操作简便，折叠手柄便于携带。采用耐用的塑料和钢结构，适用于客厅、卧室、办公室或任何需要额外温暖的空间。',
      category: '便携式取暖器',
      features: ['双档加热', '折叠手柄', '碳纤维加热', '便携设计', '操作简便'],
      specs: [
        { label: '型号', value: 'JHL023' },
        { label: '产品名称', value: '落地式取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '1500W (最大)' },
        { label: '档位设置', value: '750W + 750W' },
        { label: '控制方式', value: '旋转开关' },
        { label: '加热元件', value: '碳纤维加热管 x 2' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '材质', value: '塑料、钢材' },
        { label: '特点', value: '折叠手柄' }
      ]
    },
    p11: {
      name: 'JHL023-05',
      description: '紧凑型碳纤维取暖器，双档加热设置。适用于中小空间的高效节能取暖器。',
      longDescription:
        'JHL023-05是一款紧凑节能的落地式取暖器，非常适合中小空间使用。配备双碳纤维加热管，两档可调设置（400W + 400W），在提供舒适温暖的同时节约能源。旋转开关操作简便，折叠手柄确保便于存放和携带。是卧室、家庭办公室或个人工作空间的理想选择。',
      category: '便携式取暖器',
      features: ['双档加热', '折叠手柄', '碳纤维加热', '紧凑便携', '高效节能'],
      specs: [
        { label: '型号', value: 'JHL023-05' },
        { label: '产品名称', value: '落地式取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '800W (最大)' },
        { label: '档位设置', value: '400W + 400W' },
        { label: '控制方式', value: '旋转开关' },
        { label: '加热元件', value: '碳纤维加热管 x 2' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '材质', value: '塑料、钢材' },
        { label: '特点', value: '折叠手柄' }
      ]
    },
    p12: {
      name: 'JHL021-S',
      description: '多功能取暖器配备LED氛围灯和蓝牙音箱。营造温馨舒适氛围的理想选择。',
      longDescription:
        'JHL021-S是一款将取暖功能与娱乐功能相结合的创新取暖器。配备16色LED氛围灯，可为任何场景营造完美氛围。内置蓝牙音箱，支持手机连接播放音乐。拨动开关控制加热设置，遥控器控制蓝牙和LED功能。配备倾倒保护功能，凉触网设计有效防止烫伤。碳纤维加热管提供高效快速加热。适用于客厅、卧室或任何需要温暖和氛围的室内空间。',
      category: '便携式取暖器',
      features: ['16色LED灯', '蓝牙音箱', '倾倒保护', '凉触网设计', '遥控控制'],
      specs: [
        { label: '型号', value: 'JHL021-S' },
        { label: '产品名称', value: 'LED蓝牙取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '1500W' },
        { label: '控制方式', value: '拨动开关(加热), 遥控(蓝牙&LED)' },
        { label: 'LED灯', value: '16色氛围灯' },
        { label: '加热元件', value: '1根碳纤维加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '安全功能', value: '倾倒保护, 凉触网' },
        { label: '材质', value: '铁、铝合金' }
      ]
    },
    p13: {
      name: 'JHL004-B',
      description: '强大3000W卤素取暖器，配伸缩杆。可调节高度以适应不同加热需求。',
      longDescription:
        'JHL004-B是一款专为户外和半户外空间设计的强大落地式露台取暖器。配备双卤素加热管，提供三档可调功率设置（1200W-1800W-3000W），提供高效舒适的温暖。伸缩杆高度可在1.6米至2.08米之间调节，满足不同区域的加热需求。同时配备遥控器和触摸按钮，操作便捷。具备倾倒保护功能，使用安全。铁铝合金材质结合现代设计，确保耐用性的同时保持优雅外观。适用于露台、甲板、花园和户外娱乐区。',
      category: '便携式取暖器',
      features: ['3000W大功率', '伸缩杆设计', '三档加热', '遥控&触摸控制', '倾倒保护'],
      specs: [
        { label: '型号', value: 'JHL004-B' },
        { label: '产品名称', value: '落地式露台取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '3000W (最大)' },
        { label: '档位设置', value: '1200W-1800W-3000W' },
        { label: '控制方式', value: '遥控器和触摸按钮' },
        { label: '高度', value: '伸缩杆 (1.6m - 2.08m)' },
        { label: '加热元件', value: '2根卤素加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '安全功能', value: '倾倒保护' },
        { label: '材质', value: '铁、铝合金' }
      ]
    },
    p14: {
      name: 'JHL001-BZ',
      description: '高效卤素露台取暖器，固定杆设计。为户外空间提供时尚美观的取暖解决方案。',
      longDescription:
        'JHL001-BZ是一款时尚高效的露台取暖器，采用固定杆设计。配备双卤素加热管，提供三档可调功率设置（900W-1200W-2100W），提供舒适温暖的加热效果。布艺外观设计增添时尚感，同时保持功能性。同时配备遥控器和触摸按钮，操作便捷。具备倾倒保护功能，使用安全。铁铝合金材质确保耐用性和高效散热。适用于封闭式露台、凉亭和其他半户外空间，是时尚与温暖兼具的理想选择。',
      category: '便携式取暖器',
      features: ['三档加热', '布艺设计', '遥控&触摸控制', '倾倒保护', '高效卤素加热'],
      specs: [
        { label: '型号', value: 'JHL001-BZ' },
        { label: '产品名称', value: '布艺露台取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '2100W (最大)' },
        { label: '档位设置', value: '900W-1200W-2100W' },
        { label: '控制方式', value: '遥控器和触摸按钮' },
        { label: '高度', value: '固定杆' },
        { label: '加热元件', value: '2根卤素加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '安全功能', value: '倾倒保护' },
        { label: '材质', value: '铁、铝合金' }
      ]
    },
    p15: {
      name: 'JHD028-B',
      description: '强大2000W天花板安装卤素取暖器，三档加热设置。适用于高天花板空间的理想选择。',
      longDescription:
        'JHD028-B是一款专为高效加热室内空间而设计的天花板安装取暖器。配备两根卤素加热管，提供三档可调功率设置（800W-1200W-2000W），提供强大均匀的加热效果。天花板安装方式节省地面空间，同时从上往下提供良好的热量分布。同时配备遥控器和触摸按钮，操作便捷。铝合金和铁材质确保耐用性和高效导热。适用于高天花板房间、车库、车间或任何偏好天花板安装的空间。持续提供舒适温暖，不占用地面空间。',
      category: '便携式取暖器',
      features: ['天花板安装', '2根卤素管', '三档加热', '遥控&触摸控制', '节省空间'],
      specs: [
        { label: '型号', value: 'JHD028-B' },
        { label: '产品名称', value: '天花板取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '2000W (最大)' },
        { label: '档位设置', value: '800W-1200W-2000W' },
        { label: '控制方式', value: '遥控器和触摸按钮' },
        { label: '加热元件', value: '2根卤素加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '材质', value: '铝合金、铁' }
      ]
    },
    p16: {
      name: 'JHG019-B',
      description: '智能碳纤维取暖器配定时功能。壁挂设计节省空间，提供强大温暖。',
      longDescription:
        'JHG019-B是一款先进的壁挂式露台取暖器，采用碳纤维加热技术。提供三档可调功率设置（650W-1300W-2000W），提供强大高效的温暖。配备拨动开关、遥控器和触摸按钮多种控制方式，操作便捷。内置定时器功能可设置最长8小时自动关机，节约能源并提供安心保障。碳纤维加热管确保快速加热和优异的热量分布。壁挂设计节省宝贵的地面空间，同时提供强大温暖。铁铝合金材质经久耐用。适用于露台、车库、车间或任何偏好壁挂安装的室内外空间。',
      category: '便携式取暖器',
      features: ['壁挂安装', '碳纤维加热', '8小时定时', '多种控制方式', '节省空间设计'],
      specs: [
        { label: '型号', value: 'JHG019-B' },
        { label: '产品名称', value: '壁挂式露台取暖器' },
        { label: '电压', value: '220-240V~50Hz' },
        { label: '功率', value: '2000W (最大)' },
        { label: '档位设置', value: '650W-1300W-2000W' },
        { label: '开关', value: '拨动开关, 遥控和触摸控制' },
        { label: '遥控', value: '是' },
        { label: '定时器', value: '是, 最长8小时' },
        { label: '加热元件', value: '碳纤维加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '1.8-1.9m' },
        { label: '材质', value: '铁、铝合金' }
      ]
    },
    p17: {
      name: 'JH-104',
      description: '高效壁挂式取暖器，配备红金卤素管。紧凑设计适用于各类室内空间。',
      longDescription:
        'JH-104是一款专为室内空间设计的高效壁挂式取暖器。配备红金卤素管，提供快速高效的加热效果。三档可调功率设置（800W/1300W/2000W）让您可以根据需要自定义舒适温度。配备遥控器，操作便捷。时尚紧凑的设计适合任何房间，同时提供强大温暖。适用于客厅、卧室、办公室或任何偏好壁挂安装的室内空间。',
      category: '便携式取暖器',
      features: ['壁挂式安装', '红金卤素管', '三档加热', '遥控控制', '紧凑设计'],
      specs: [
        { label: '型号', value: 'JH-104' },
        { label: '产品名称', value: '壁挂式取暖器' },
        { label: '电压', value: '220V ~ 50Hz' },
        { label: '功率', value: '2000W (最大)' },
        { label: '档位设置', value: '800W / 1300W / 2000W' },
        { label: '控制方式', value: '遥控器' },
        { label: '加热元件', value: '红金卤素管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '3m' },
        { label: '尺寸', value: '63.5cm × 10cm' },
        { label: '重量', value: '2.2kg' }
      ]
    },
    p18: {
      name: 'JH-106',
      description: '紧凑型天花板安装取暖器，采用碳纤维科技。适用于小型室内空间。',
      longDescription:
        'JH-106是一款专为小型室内空间高效加热而设计的天花板安装取暖器。采用碳纤维加热管技术，实现快速高效加热。拉线开关提供便捷的开关控制。三档可调功率设置（600W/1000W/1500W）满足不同加热需求。天花板安装方式节省地面空间，同时提供良好的热量分布。适用于小房间、浴室、厨房或任何偏好天花板安装的空间。',
      category: '便携式取暖器',
      features: ['天花板安装', '碳纤维科技', '三档加热', '拉线开关', '节省空间'],
      specs: [
        { label: '型号', value: 'JH-106' },
        { label: '产品名称', value: '天花板取暖器' },
        { label: '电压', value: '220V ~ 50Hz' },
        { label: '功率', value: '1500W (最大)' },
        { label: '档位设置', value: '600W / 1000W / 1500W' },
        { label: '控制方式', value: '拉线开关' },
        { label: '加热元件', value: '碳纤维加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '3m' },
        { label: '尺寸', value: '42cm (直径) × 30cm (高度)' },
        { label: '重量', value: '2.3kg' }
      ]
    },
    p19: {
      name: 'JH-3000',
      description: '高端可调节露台取暖器，支持手机APP控制。非常适合户外娱乐。',
      longDescription:
        'JH-3000是一款专为户外娱乐设计的高端可调节露台取暖器。采用先进的碳纤维加热管技术，提供强大高效的温暖。可调节高度（160-205cm）满足不同加热需求。同时配备遥控器和手机APP控制，操作便捷。三档可调功率设置（1200W/1800W/3000W）提供个性化的舒适温度。坚固的底座直径45cm，确保稳定性。适用于露台、甲板、花园和户外娱乐区。',
      category: '便携式取暖器',
      features: ['可调节高度', '碳纤维加热', '三档加热', '手机APP控制', '遥控控制'],
      specs: [
        { label: '型号', value: 'JH-3000' },
        { label: '产品名称', value: '黑色遮阳伞可调节露台取暖器' },
        { label: '电压', value: '220V ~ 50Hz' },
        { label: '功率', value: '3000W (最大)' },
        { label: '档位设置', value: '1200W / 1800W / 3000W' },
        { label: '控制方式', value: '遥控器和手机APP' },
        { label: '加热元件', value: '碳纤维加热管' },
        { label: '插头', value: '欧标插头' },
        { label: '电源线', value: '5m' },
        { label: '高度', value: '可调节, 160-205cm' },
        { label: '底座直径', value: '45cm' },
        { label: '重量', value: '12kg' }
      ]
    },
  },
};
